import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeText extends TraitRegistryItem {
    constructor(init = {}) {
        super(init);
        Object.assign(this, init);
    }
}
